import { svg } from "lit";
const icon = svg `<path d="M12 19.8463L5.50007 16.3155V10.8924L2.03857 9.00017L12 3.57715L21.9615 9.00017V16.1924H20.4616V9.83092L18.5 10.8924V16.3155L12 19.8463ZM12 12.7002L18.8404 9.00017L12 5.30017L5.15967 9.00017L12 12.7002ZM12 18.1386L17.0001 15.4386V11.6924L12 14.4214L7.00005 11.6924V15.4386L12 18.1386Z" fill="currentColor"/>`;
export default icon;
